import Vue from 'vue'

export default
{
    namespaced: true,
    
    state:
    {
        healthStats: {},
        covidHelp: {}
    },

    getters:
    {
        getHealthStatsForZipcode: state => (zipcode) =>
        {
            zipcode = zipcode.toString()
            const stats = {}

            for(let [date, dayStats] of Object.entries(state.healthStats))
            {
                if (!date) continue
                stats[date] = dayStats.find(s => s.code == 'DEP-' + zipcode.substr(0, 2))
            }

            return stats
        }
    },

    mutations:
    {
        updateHealthStats (state, healthStats)
        {
            for (let stats of healthStats)
            {
                const existing = state.healthStats[stats.date] || []
                existing.push(stats)

                Vue.set(state.healthStats, stats.date, existing)
            }
        },

        setCovidHelp (state, covidHelp) 
        {
            state.covidHelp = covidHelp
        }
    },
}


// WEBPACK FOOTER //
// ./src/stores/covid.js